import { z } from "zod";

export const FinancialInfoSchema = z
  .object({
    actividadEconomica: z
      .string({ required_error: "La actividad económica es obligatoria" })
      .min(1, "La actividad económica es obligatoria"),
    codigoCiiu: z
      .string({ required_error: "Debe seleccionar un código CIIU" })
      .min(1, "Debe seleccionar un código CIIU"),
    ingresosAnuales: z
      .number({ required_error: "Debe ser un valor" })
      .nonnegative("Debe ser un valor positivo"),
    otrosIngresos: z
      .number({ required_error: "Debe ser un valor" })
      .nonnegative("Debe ser un valor positivo"),
    totalIngresos: z
      .number({ required_error: "Debe ser un valor" })
      .nonnegative("Debe ser un valor positivo"),
    activos: z
      .number({ required_error: "Debe ser un valor" })
      .nonnegative("Debe ser un valor positivo"),
    pasivos: z
      .number({ required_error: "Debe ser un valor" })
      .nonnegative("Debe ser un valor positivo"),
    patrimonio: z
      .number({ required_error: "Debe ser un valor" })
      .nonnegative("Debe ser un valor positivo"),
    conceptoOtrosIngresos: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.totalIngresos !== (data.ingresosAnuales + data.otrosIngresos)) {
      ctx.addIssue({
        path: ["totalIngresos"],
        code: "custom",
        message:
          "El total de ingresos debe ser igual a Ingresos + Otros ingresos",
      });
    }

    if (data.patrimonio !== (data.activos - data.pasivos)) {
      ctx.addIssue({
        path: ["patrimonio"],
        code: "custom",
        message:
          "El total de ingresos debe ser igual a Ingresos + Otros ingresos",
      });
    }
  });

export type FinancialInfo = z.infer<typeof FinancialInfoSchema>;
